import { get } from 'lodash';

import { Item } from './item-data-store';

export const id = (item: Item) => get(item, 'id');

export const identifier = (item: Item) => {
    const barCode = get(item, 'identificationItemSchema.barCodes.translatedString.fr', item.id);

    const uniqueIdentifier = get(item, 'identificationItemSchema.identifiers[0].identifier');

    return uniqueIdentifier || barCode;
};

export const media = (item: Item) => {
    const otherMedia = get(item, 'associatedMedias.mediaFiles.0.mediaId', null);
    const third = get(item, 'associatedMedias.third');
    const second = get(item, 'associatedMedias.second');
    const first = get(item, 'associatedMedias.first');

    return first || second || third || otherMedia;
};

export const manifestation = (item: Item) => get(item, 'linkToManifestation.referentManifestation');

export const permanentLocation = (item: Item) =>
    get(item, 'locationItemSchema.permanentLocation.permanentLocation');

export const realTimeLocation = (item: Item) =>
    get(item, 'locationItemSchema.realTimeLocation.realTimeLocation');
